import { render, staticRenderFns } from "./PlanCard.vue?vue&type=template&id=4cc61b3b&scoped=true&"
import script from "./PlanCard.vue?vue&type=script&lang=js&"
export * from "./PlanCard.vue?vue&type=script&lang=js&"
import style0 from "./PlanCard.vue?vue&type=style&index=0&id=4cc61b3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc61b3b",
  null
  
)

export default component.exports